import React, { useState } from 'react';
import Quote from './Quote';
import { fetchRandomQuote, getErrorMessage } from '../api/quotes';

const QuoteCreator = () => {
    const [word1, setWord1] = useState('');
    const [word2, setWord2] = useState('');
    const [word3, setWord3] = useState('');
    const [name, setName] = useState('');
    const [quote, setQuote] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setQuote(null);
        try {
            const raw = await fetchRandomQuote();

            // Replace the first 3 words using an external counter so we count words,
            // not string byte offsets (which is what the regex `index` param gives).
            let wordCount = 0;
            const replacements = [word1, word2, word3];
            const modifiedText = raw.quote.replace(/\b\w+\b/g, (match) => {
                if (wordCount < 3) return replacements[wordCount++];
                return match;
            });

            setQuote({ text: modifiedText, author: name });
        } catch (err) {
            setError(getErrorMessage(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="quote-creator">
            <form className="creator-form" onSubmit={handleSubmit}>
                <div>
                    <label className="form-label">Replace the first 3 words</label>
                    <div className="input-row">
                        <input
                            type="text"
                            placeholder="First word"
                            value={word1}
                            onChange={(e) => setWord1(e.target.value)}
                            required
                        />
                        <input
                            type="text"
                            placeholder="Second word"
                            value={word2}
                            onChange={(e) => setWord2(e.target.value)}
                            required
                        />
                        <input
                            type="text"
                            placeholder="Third word"
                            value={word3}
                            onChange={(e) => setWord3(e.target.value)}
                            required
                        />
                    </div>
                </div>
                <div>
                    <label className="form-label">Your name</label>
                    <input
                        type="text"
                        placeholder="How should we credit you?"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                    />
                </div>
                <button type="submit" disabled={loading}>
                    {loading ? 'Creating…' : 'Generate My Quote'}
                </button>
            </form>
            {error && <p className="error-text">{error}</p>}
            {quote && <Quote quote={quote} />}
        </div>
    );
};

export default QuoteCreator;
